import { LIST_ACTIONS } from 'lib/list-helper/makeListReducer';
import useQueryList from 'lib/list-helper/useQueryList';
import {
  reducer,
  initialState,
  INSPECTION_PLANS_LIST_PAGE_ACTIONS,
} from './inspectionPlansListReducer';
import inspectionPlansService from './inspectionPlansService';
import debounce from 'lodash.debounce';
import { downloadResponse } from 'lib/download';
import { noop } from 'lib/funcHelpers';

const setFilters = (params) => {
  let filters = { ...params.filters };
  if (params?.byAssetId) {
    filters = { ...filters, byAssetId: params.byAssetId };
  }
  if (params?.bySourceId) {
    filters = { ...filters, bySourceId: params.bySourceId };
  }
  return filters;
};

const fetchInspectionPlans = debounce((params, _, dispatch) => {
  dispatch({ type: LIST_ACTIONS.SET_LOADING, payload: true });
  const filters = setFilters(params);
  return inspectionPlansService
    .getInspectionPlans({ ...params, filters })
    .then((results) => {
      dispatch({
        type: LIST_ACTIONS.APP_LOADS_DATA,
        payload: { ...results },
      });
      return results;
    })
    .catch((e) => {
      dispatch({
        type: LIST_ACTIONS.SHOW_ERROR,
        payload: e.message,
      });
    })
    .then(() => {
      dispatch({ type: LIST_ACTIONS.SET_LOADING, payload: false });
    });
}, 400);

const useInspectionPlansList = ({ location, history }) => {
  const { dispatch, ...list } = useQueryList(
    location,
    history,
    reducer,
    initialState,
    fetchInspectionPlans,
  );

  const userClicksOnRow = (id) => {
    history.push(`/inspection-plans/${id}`);
  };

  const userClicksOnAdd = () => {
    history.push(`/inspection-plans/add`);
  };

  const userClicksOnExportUserEditedPlans = () => {
    dispatch({
      type: INSPECTION_PLANS_LIST_PAGE_ACTIONS.USER_STARTS_EXPORT,
    });

    inspectionPlansService
      .exportUserEditedPlans()
      .then((data) => {
        downloadResponse(data, 'user-edited-inspection-plans.csv');
      })
      // The service already logs the failure; swallow it so the button recovers.
      .catch(noop)
      .finally(() => {
        dispatch({
          type: INSPECTION_PLANS_LIST_PAGE_ACTIONS.APP_FINISHES_EXPORT,
        });
      });
  };

  return {
    ...list,
    userClicksOnRow,
    userClicksOnAdd,
    userClicksOnExportUserEditedPlans,
  };
};

export default useInspectionPlansList;
